export default __webpack_public_path__ + "static/media/whatsapp.d6a68d72.svg";